
/* RegalStore CRO Premium JavaScript v2.0 */
(function() {
  'use strict';

  // ============================================
  // 1. STICKY ADD TO CART (Mobile)
  // ============================================
  function initStickyATC() {
    const productForm = document.querySelector('.product-form');
    if (!productForm) return;
    
    const atcBtn = document.querySelector('.product-form__submit');
    if (!atcBtn) return;
    
    // Create sticky bar
    const stickyBar = document.createElement('div');
    stickyBar.className = 'rs-sticky-atc';
    stickyBar.id = 'rs-sticky-atc';
    stickyBar.style.cssText = `
      position: fixed;
      bottom: -80px;
      left: 0;
      right: 0;
      z-index: 999;
      background: rgba(255,255,255,0.97);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      padding: 12px 16px 20px;
      box-shadow: 0 -4px 24px rgba(0,0,0,0.12);
      border-top: 1px solid #EFEFED;
      display: flex;
      gap: 12px;
      align-items: center;
      transition: bottom 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    `;
    
    // Get price info
    const price = document.querySelector('.price');
    const priceText = price ? price.textContent.trim().split('\n')[0].trim() : '';
    
    // Get product title
    const title = document.querySelector('.product__title');
    const titleText = title ? title.textContent.trim() : '';
    
    stickyBar.innerHTML = `
      <div style="flex-shrink:0;min-width:0;">
        <div style="font-size:11px;color:#8A8A88;font-weight:600;letter-spacing:0.04em;text-transform:uppercase;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:120px;">${titleText.substring(0, 25)}</div>
        <div style="font-size:1.3rem;font-weight:800;color:#1A1A2E;line-height:1.1;">${priceText}</div>
      </div>
      <button id="rs-sticky-btn" style="flex:1;background:linear-gradient(135deg,#2C5F2E,#2E6B30);color:white;border:none;border-radius:10px;padding:16px;font-weight:800;font-size:15px;letter-spacing:0.05em;text-transform:uppercase;cursor:pointer;box-shadow:0 4px 14px rgba(44,95,46,0.35);">
        🛒 ADAUGĂ ÎN COȘ
      </button>
    `;
    
    document.body.appendChild(stickyBar);
    
    // Sticky button click - submits the main form
    document.getElementById('rs-sticky-btn').addEventListener('click', function() {
      if (atcBtn && !atcBtn.disabled) {
        atcBtn.click();
        this.textContent = '✓ ADĂUGAT!';
        this.style.background = 'linear-gradient(135deg, #1A5C1A, #147814)';
        setTimeout(() => {
          this.innerHTML = '🛒 ADAUGĂ ÎN COȘ';
          this.style.background = 'linear-gradient(135deg, #2C5F2E, #2E6B30)';
        }, 2000);
      }
    });
    
    // Show/hide based on scroll position
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        const sticky = document.getElementById('rs-sticky-atc');
        if (!sticky) return;
        if (!entry.isIntersecting) {
          // ATC button is out of view - show sticky bar on mobile
          if (window.innerWidth <= 768) {
            sticky.style.bottom = '0';
          }
        } else {
          sticky.style.bottom = '-80px';
        }
      });
    }, { threshold: 0.5 });
    
    observer.observe(atcBtn);
  }

  // ============================================
  // 2. HEADER SCROLL EFFECT
  // ============================================
  function initHeaderScroll() {
    const header = document.querySelector('.header, .site-header, header');
    if (!header) return;
    
    let lastScrollY = 0;
    let ticking = false;
    
    window.addEventListener('scroll', function() {
      lastScrollY = window.scrollY;
      if (!ticking) {
        requestAnimationFrame(function() {
          if (lastScrollY > 80) {
            header.classList.add('scrolled');
            header.style.boxShadow = '0 4px 20px rgba(0,0,0,0.1)';
          } else {
            header.classList.remove('scrolled');
            header.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // ============================================
  // 3. PRODUCT IMAGE ZOOM ON HOVER (Desktop)
  // ============================================
  function initImageHoverZoom() {
    const productImages = document.querySelectorAll('.product__media-item img');
    productImages.forEach(img => {
      img.style.transition = 'transform 0.4s ease';
      img.addEventListener('mouseenter', () => img.style.transform = 'scale(1.05)');
      img.addEventListener('mouseleave', () => img.style.transform = 'scale(1)');
    });
  }

  // ============================================
  // 4. SCROLL TO TOP BUTTON
  // ============================================
  function initScrollToTop() {
    const btn = document.createElement('button');
    btn.innerHTML = '↑';
    btn.style.cssText = `
      position: fixed;
      bottom: 90px;
      right: 20px;
      z-index: 998;
      width: 44px;
      height: 44px;
      background: linear-gradient(135deg, #2C5F2E, #2E6B30);
      color: white;
      border: none;
      border-radius: 50%;
      font-size: 18px;
      cursor: pointer;
      box-shadow: 0 4px 14px rgba(44,95,46,0.35);
      transition: all 0.25s ease;
      opacity: 0;
      transform: translateY(10px);
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    
    document.body.appendChild(btn);
    
    btn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
    btn.addEventListener('mouseenter', () => btn.style.transform = 'translateY(-2px)');
    btn.addEventListener('mouseleave', () => btn.style.transform = 'translateY(0)');
    
    window.addEventListener('scroll', () => {
      if (window.scrollY > 400) {
        btn.style.opacity = '1';
        btn.style.transform = 'translateY(0)';
      } else {
        btn.style.opacity = '0';
        btn.style.transform = 'translateY(10px)';
      }
    }, { passive: true });
  }

  // ============================================
  // 5. URGENCY / SOCIAL PROOF ON PRODUCT PAGE
  // ============================================
  function initUrgencyBadge() {
    const atcSection = document.querySelector('.product-form__buttons, .product-form');
    if (!atcSection) return;
    
    // Random viewers (social proof)
    const viewersCount = Math.floor(Math.random() * 8) + 3;
    const viewerBadge = document.createElement('div');
    viewerBadge.style.cssText = `
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 10px 14px;
      background: rgba(44, 95, 46, 0.06);
      border-radius: 8px;
      border: 1px solid rgba(44, 95, 46, 0.15);
      margin-bottom: 12px;
      font-size: 13px;
      color: #2C5F2E;
      font-weight: 600;
    `;
    viewerBadge.innerHTML = `
      <span style="width:8px;height:8px;background:#2C5F2E;border-radius:50%;animation:pulse 1.5s infinite;flex-shrink:0;"></span>
      <span>${viewersCount} persoane văd acest produs acum</span>
    `;
    
    atcSection.parentNode.insertBefore(viewerBadge, atcSection);
  }

  // ============================================
  // 6. ANIMATE NUMBERS ON SCROLL
  // ============================================
  function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('.card-wrapper, .collection-list__item');
    
    if (!('IntersectionObserver' in window)) return;
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.animation = 'fadeInUp 0.4s ease forwards';
          entry.target.style.opacity = '0';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    
    animatedElements.forEach(el => observer.observe(el));
  }

  // ============================================
  // 7. SMOOTH ANCHOR LINKS
  // ============================================
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href^="#"]');
    if (link) {
      const target = document.querySelector(link.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });

  // ============================================
  // 8. ANIMATION KEYFRAMES
  // ============================================
  const style = document.createElement('style');
  style.textContent = `
    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(20px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @keyframes pulse {
      0%, 100% { opacity: 1; transform: scale(1); }
      50% { opacity: 0.5; transform: scale(0.85); }
    }
  `;
  document.head.appendChild(style);

  // ============================================
  // INIT ALL
  // ============================================
  function init() {
    initHeaderScroll();
    initScrollToTop();
    
    // Product page specific
    if (document.querySelector('.product-form')) {
      initStickyATC();
      initImageHoverZoom();
      initUrgencyBadge();
    }
    
    // Homepage / collection specific
    // initScrollAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();



/* ============================================
   CLEANUP: remove any old custom buy-now buttons
   ============================================ */
(function() {
  function cleanOld() {
    document.querySelectorAll('.rs-buy-now-btn').forEach(b => b.remove());
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanOld);
  } else {
    cleanOld();
  }
  setTimeout(cleanOld, 500);
  setTimeout(cleanOld, 1500);
})();

/* ============================================
   COD BUTTON INJECTOR ON PRODUCT CARDS
   Adds a "Cumpărați cu Plata la Livrare" button on
   every product card (homepage, collections, recommendations)
   that navigates to the product page and triggers the
   Releasit COD form modal automatically.
   ============================================ */
(function() {
  
  function getProductUrl(card) {
    // Find link to product
    const link = card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0].split('#')[0] : null;
  }
  
  function cleanupOldPositions() {
    // Remove any existing rs-card-cod-btn that was placed in wrong location (inside .card__inner)
    document.querySelectorAll('.rs-card-cod-btn').forEach(btn => {
      if (btn.closest('.card__inner')) {
        btn.remove();
      }
    });
  }
  
  function injectCardCod() {
    cleanupOldPositions();
    // ONLY on listings, NOT on the main product page form
    const cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper, .card');
    cards.forEach(card => {
      // Skip if not a product card
      if (!card.querySelector('a[href*="/products/"]')) return;
      // Avoid duplicates
      if (card.querySelector('.rs-card-cod-btn')) return;
      // Skip if inside the main product info container (e.g. recommended products inside product page are OK,
      // but main product form should be untouched)
      if (card.closest('.product-form__buttons')) return;
      
      const url = getProductUrl(card);
      if (!url) return;
      
      const btn = document.createElement('a');
      btn.className = 'rs-card-cod-btn';
      btn.href = url + '#cumpara-cod';
      btn.setAttribute('aria-label', 'Cumpărați cu Plata la Livrare');
      btn.innerHTML = '<span class="rs-card-cod-icon" aria-hidden="true">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor">' +
        '<path d="M3 6h13v8H3zM16 10h3l2 3v1h-5zM5 17a2 2 0 1 0 0 .01M17 17a2 2 0 1 0 0 .01"/>' +
        '<path d="M5 13.5V6h11v7.5M16 9h3l2 3v2h-2" stroke="currentColor" stroke-width="1.5" fill="none"/>' +
        '</svg></span>' +
        '<span class="rs-card-cod-label">Plata la Livrare</span>';
      
      // Place button AFTER the quick-add (so it appears below "Adăugați în coș")
      const quickAdd = card.querySelector('.quick-add');
      if (quickAdd && quickAdd.parentElement) {
        // Insert right after quick-add
        if (quickAdd.nextSibling) {
          quickAdd.parentElement.insertBefore(btn, quickAdd.nextSibling);
        } else {
          quickAdd.parentElement.appendChild(btn);
        }
      } else {
        // Fallback: find the OUTER card__content (not the one inside .card__inner which overlays the image)
        const allContents = card.querySelectorAll('.card__content');
        let target = null;
        // Pick the card__content that is NOT inside .card__inner
        for (const c of allContents) {
          if (!c.closest('.card__inner')) { target = c; break; }
        }
        // Fallback to .card-information
        if (!target) target = card.querySelector('.card-information');
        if (!target) target = card;
        target.appendChild(btn);
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectCardCod);
  } else {
    injectCardCod();
  }
  
  // Re-inject when new content loads (filters, pagination, infinite scroll)
  const observer = new MutationObserver(function(muts) {
    let shouldRun = false;
    for (const m of muts) {
      for (const n of m.addedNodes) {
        if (n.nodeType === 1 && (
          (n.classList && (n.classList.contains('card-wrapper') || n.classList.contains('card'))) ||
          (n.querySelector && n.querySelector('.card-wrapper, .card'))
        )) {
          shouldRun = true;
          break;
        }
      }
      if (shouldRun) break;
    }
    if (shouldRun) injectCardCod();
  });
  if (document.body) observer.observe(document.body, { childList: true, subtree: true });
  
  // Periodic safety check
  setTimeout(injectCardCod, 1000);
  setTimeout(injectCardCod, 2500);
})();

/* ============================================
   AUTO-OPEN RELEASIT MODAL ON PRODUCT PAGE
   When user lands on product page with #cumpara-cod hash,
   automatically click the Releasit COD button
   ============================================ */
(function() {
  if (window.location.hash !== '#cumpara-cod') return;
  
  function tryOpenModal(attempts) {
    attempts = attempts || 0;
    if (attempts > 20) return; // ~10 sec max
    
    const releasit = document.querySelector('._rsi-buy-now-button._rsi-buy-now-button-product, ._rsi-buy-now-button-product');
    if (releasit && releasit.offsetHeight > 0) {
      releasit.click();
      // Clean the hash so refresh doesn't re-open
      try { history.replaceState(null, '', window.location.pathname + window.location.search); } catch(e) {}
      return;
    }
    setTimeout(function() { tryOpenModal(attempts + 1); }, 500);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { tryOpenModal(0); });
  } else {
    tryOpenModal(0);
  }
})();
